import { calculateScrollability } from './calculate-scrollability';

// We need left end and right start because gradient looks like this:
// 0-------leftGradientEndPercent------------rightGradientStartPercent-------100;
// so we only need to know when to stop left gradient and when to start right gradient!
export const getToolbarGradientPercents = (element: HTMLDivElement | null, isRtl: boolean) => {
  if (element === null || element.scrollWidth === element.clientWidth) {
    return;
  }

  const { clientWidth } = element;
  const maxGradientWidth = Math.min(100, clientWidth * 0.9);
  const scrollability = calculateScrollability(element, isRtl);

  return {
    leftGradientEndPercent:
      ((maxGradientWidth * scrollability.amountScrollableToLeft) / clientWidth) * 100,
    rightGradientStartPercent:
      100 - ((maxGradientWidth * scrollability.amountScrollableToRight) / clientWidth) * 100,
  };
};
